module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-regular.501ce09c.woff2";